export const progressStatusFor = (pct) =>
  pct >= 100 ? "Goal Achieved" : pct >= 75 ? "On Pace" : pct >= 50 ? "Making Progress" : "Needs Acceleration";

// The active workspace is the source of truth for goal and context; fall back to the API metrics otherwise.
export const effectiveMetricsFor = (metrics, instance) => {
  if (!metrics) return null;
  if (!instance) return metrics;
  const currentRevenue = instance.currentRevenue || 0;
  const revenueGoal = instance.revenueGoal || 0;
  return {
    ...metrics,
    currentRevenue,
    revenueGoal,
    progressPercentage: revenueGoal > 0 ? (currentRevenue / revenueGoal) * 100 : 0,
    goalEndDate: instance.goalEndDate,
    companyName: instance.companyName,
    icp: instance.icp,
  };
};
